export const LOCAL_STORAGE_SELECTED_CAMERA_ID_KEY = 'device.mainvideo.id';
export const LOCAL_STORAGE_SELECTED_MICROPHONE_ID_KEY = 'device.mainaudio.id';
export const LOCAL_STORAGE_RETURN_URL_KEY = 'return-url';
export const LOCAL_STORAGE_INITIAL_URL_PARAMS_KEY = 'initial-url-params';
export const LOCAL_STORAGE_INVITE_CODE_KEY = 'invite-code';
export const LOCAL_STORAGE_RANDOMIZER = 'randomizer';
